import { z } from 'zod';

import { PaginationResponseSchema } from '@/shared/global.schema';

const NotificationItemSchema = z.any();

export const ResponseNotificationsSchema = z.object({
    data: z.array(NotificationItemSchema),
    pagination: PaginationResponseSchema,
});

export type NotificationItem = z.infer<typeof NotificationItemSchema>;
export type ResponseNotifications = z.infer<typeof ResponseNotificationsSchema>;
